import React from 'react'
import { Form } from 'antd';
import { useCommentList } from '../hooks/useCommentList';
import ContainerCommentList from './ContainerCommentList';


export const CommentList = ({
    nameList = "uno",
    reasons = {
        title: "Motivo",
        description: "Selecciona una o más motivos a donde está dirigido tu comentario",
        items: [],
        placeholder: "Selecciona uno o más motivos",
        isRequired: true,
    },
    comments = {
        title: "Motivo",
        description: "Selecciona una o más motivos a donde está dirigido tu comentario",
        placeholder: "Selecciona uno o más motivos",
        isRequired: true,
    },
    rules = null,
    disableIputs = false
}) => {

    const {
        buttonsCheked,
        checkAll,
        isBlockNewComment,
        handleAddComment,
        handleDeleteComment,
        handleSaveComment,
        handleSelectChange
    } = useCommentList({ nameList, reasons, rules })


    return (
        <Form.List name={nameList}>
            {(fields, { add, remove }) => (
                <ContainerCommentList
                    disableIputs={disableIputs}
                    fields={fields}
                    add={add}
                    remove={remove}
                    nameList={nameList}
                    reasons={reasons}
                    comments={comments}
                    buttonsCheked={buttonsCheked}
                    checkAll={checkAll}
                    isBlockNewComment={isBlockNewComment}
                    rules={rules}
                    handleAddComment={handleAddComment}
                    handleSaveComment={handleSaveComment}
                    handleDeleteComment={handleDeleteComment}
                    handleSelectChange={handleSelectChange}
                />
            )}
        </Form.List>
    );
}